"use client";

import {
  usePathname
} from "next/navigation";
import {
  useEffect
} from "react";

/**
 * Component to track page views in the application
 * Place this component in your root layout or near the top of your component tree
 */
export function PageViewTracker() {
  const pathname = usePathname();

  useEffect(() => {
    // Track new page view when pathname changes
    const trackPageView = () => {
      try {
        // Only track if the user hasn't interacted with the shape trigger
        const currentViews = localStorage.getItem("shape_page_views")
          ? parseInt(localStorage.getItem("shape_page_views") || "0")
          : 0;

        // Only increment if under the limit of 3
        if (currentViews < 8) {
          localStorage.setItem("shape_page_views", (currentViews + 1).toString());
        }
      } catch (error) {
        console.error("Error tracking page view:", error);
      }
    };

    trackPageView();
  }, [pathname]); // Run when pathname changes

  // This component doesn't render anything
  return null;
}

/**
 * Hook to reset page view counts
 * Call this when needed to reset the visibility of the shape trigger
 */
export function useResetShapeViews() {
  const resetViews = () => {
    try {
      localStorage.removeItem("shape_page_views");
    } catch (error) {
      console.error("Error resetting shape views:", error);
    }
  };

  return resetViews;
}
